import React, {PropTypes as T} from 'react';

const ModalSuccessIcon = ({ width = 24, height = 24, color, className = '' }) => (
  <svg
    aria-label="Modal Success Icon"
    viewBox="0 0 22 22"
    xmlns="http://www.w3.org/2000/svg"
    fill={color}
    width={width}
    height={height}
    className={`icon__modalsuccess ${className}`}>
    <path style={{fillRule: 'evenodd'}}
      d="M11 22c6.075 0 11-4.925 11-11S17.075 0 11 0 0 4.925 0 11s4.925 11 11 11zm0-2a9 9 0 1 0 0-18
      9 9 0 0 0 0 18zm-2.153-6.553l-2.57-2.57L5 12.152 8.847 16l7.722-7.723L15.292 7l-6.445 6.447z" />
  </svg>
);

ModalSuccessIcon.propTypes = {
  width: T.number,
  height: T.number,
  color: T.string,
  className: T.string
};

export default  ModalSuccessIcon;



// WEBPACK FOOTER //
// ./frontend/react/components/common/icons/icon_modal_success.js